import React, { FC, useMemo } from 'react';

import { useParams } from 'react-router-dom';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import { User } from '../../../common/contracts';
import { cn } from '../../../components/lib/utils';
import { DropdownMenu, DropdownMenuTrigger } from '../../../components/ui';
import { Avatar } from '../../../components/ui/avatar';

import { DROPDOWN_MENU_ITEMS } from './constants';
import DropdownMenuContent from './DropdownMenuContent';

type ProfileDropDownProps = {
  user: User | null;
};

const ProfileDropDown: FC<ProfileDropDownProps> = ({ user }) => {
  const { publisherId: publisherIdFromUrl, portalId: portalIdFromUrl } =
    useParams();

  const currentUserRole = useMemo(() => {
    if (publisherIdFromUrl && user?.projects) {
      return (
        user.projects.find(
          (project) => project.publisherId === publisherIdFromUrl
        )?.role || null
      );
    }

    if (portalIdFromUrl && user?.portals) {
      return (
        user.portals.find((portal) => portal.portalId === portalIdFromUrl)
          ?.role || null
      );
    }
    return;
  }, [publisherIdFromUrl, portalIdFromUrl]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-x-2 group focus:outline-none focus:ring-0 rounded-md border border-transparent hover:border-base-border data-[state=open]:border-base-border data-[state=open]:shadow-md py-2.5 pl-1 pr-2 data-[state=open]:rounded-b-none">
        <Avatar className="flex-auto justify-center items-center bg-[#ded6fb] w-8 h-8">
          <FontAwesomeIcon icon="fa-solid fa-user" />
        </Avatar>
        <div
          className={cn(
            'flex text-left min-w-[148px]',
            currentUserRole ? 'flex-col gap-y-1.5' : 'items-center'
          )}
        >
          <p className="text-p-s font-medium text-base-sidebarForeground leading-[100%]">
            Hi, {user?.firstName}
          </p>
          {currentUserRole && (
            <p className="text-p-xs text-indigo-600 leading-[100%]">
              {currentUserRole}
            </p>
          )}
        </div>
        <FontAwesomeIcon
          icon="fa-solid fa-chevron-down"
          className="text-neutral-600 text-p-s transition-transform group-data-[state=open]:rotate-180"
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent dropdownMenuItems={DROPDOWN_MENU_ITEMS} />
    </DropdownMenu>
  );
};

export default ProfileDropDown;
